<template>
    <div
        class="md-sold-detail fashion"
        :class="{ mobile: isMobileSize, pc: !isMobileSize }"
        :style="{ paddingTop, marginBottom }"
    >
        <!-- Mobile start -->
        <template v-if="isMobileSize">
            <DetailBanner ref="mobileBanner" />
            <div class="detail-info" ref="detailInfo">
                <module-box noPadding noMargin>
                    <!-- other components between Provided top and Provided above -->
                    <Provided
                        v-if="positionProvided && (positionProvided === PROVIDED_POSITION_KEY.above || positionProvided === PROVIDED_POSITION_KEY.top)"
                        theme="template4"
                        class="provided"
                    />
                    <div class="first-box">
                        <no-disclosure
                            v-if="hidePrice"
                            :des="cmpNondisclosureDes"
                        />
                        <p v-else class="first-price">
                            {{
                                $ft.formatCurrency({
                                    value: showSoldPrice
                                        ? info.soldPrice
                                        : info.price,
                                    noSpace: true,
                                    currencySymbol
                                })
                            }}
                        </p>
                        <span v-if="soldDate" class="sold-date">{{
                            soldDate
                        }}</span>
                    </div>

                    <!-- Original Price and Est-Price start -->
                    <div class="second-box">
                        <template v-if="showSoldPrice && showListingPrice">
                            <span class="second-price">
                                {{
                                    $ft.formatCurrency({
                                        value: info.price,
                                        noSpace: true,
                                        currencySymbol
                                    })
                                }}
                            </span>
                            <span
                                v-if="trend"
                                class="trend"
                                :class="{
                                    up: info.soldPrice > info.price,
                                    down: info.soldPrice < info.price
                                }"
                            >
                                <span class="iconfont icon-expand"></span>
                                {{ trend }}
                            </span>
                            <span class="split"></span>
                        </template>
                        <est-price class="est-price" />
                    </div>
                    <!-- Original Price and Est-Price end -->

                    <!-- Bath/Bed/Sqft start -->
                    <div class="count">
                        <div class="item" v-if="info.bedrooms > 0">
                            <span class="number">
                                {{ count('bedrooms', info.bedrooms) }}
                            </span>
                            <span class="house">{{
                                $t('md-sold-detail.bd')
                            }}</span>
                        </div>
                        <div class="item" v-if="info.bathrooms > 0">
                            <span class="number">
                                {{ count('bathrooms', info.bathrooms) }}
                            </span>
                            <span class="house">{{
                                $t('md-sold-detail.ba')
                            }}</span>
                        </div>
                        <div
                            class="item"
                            v-if="info.sqft > 0 || info.totalAvailableAcres > 0"
                        >
                            <span class="number">
                                {{
                                    count(
                                        'sqft',
                                        info.sqft,
                                        info.totalAvailableAcres
                                    )
                                }}
                            </span>
                            <span class="house">
                                {{
                                    unit(
                                        'sqft',
                                        info.sqft,
                                        info.totalAvailableAcres
                                    )
                                }}
                            </span>
                        </div>
                    </div>
                    <!-- Bath/Bed/Sqft start -->
                    <!-- address start -->
                    <template v-if="info.streetAddress || info.cityAddress">
                        <Addr
                            class="address"
                            :class="showCalculator ? '' : 'inline-block no-calculator'"
                        />
                    </template>
                    <!-- address end -->
                    <!-- calculator start -->
                    <template v-if="showCalculator">
                        <div
                            class="calculator"
                            @click="openCaculator('template4')"
                            :class="{ nodisclosure: hidePrice }"
                        >
                            <span class="iconfont icon-caculator">
                                <span class="payment-text">
                                    {{ cmpPaymentText }}
                                </span>
                            </span>
                            <span class="separator"></span>
                            <label>
                                {{
                                    $ft.formatCurrency({
                                        value: hidePrice ? '-' : pricePerMonth,
                                        noSpace: true,
                                        currencySymbol
                                    })
                                }} </label>{{ $t('md-sold-detail.mo') }}
                        </div>
                    </template>
                    <!-- calculator start -->
                </module-box>
            </div>
           
            <module-box>
                <div
                    class="detail-info-group-container"
                    ref="container"
                    :class="{ 'open-read-more': openReadMore }"
                >
                    <DetailInfoGroup ref="group" />
                    <p
                        class="read-more"
                        :class="{ open: openReadMore }"
                        v-if="showReadMore"
                        @click="onReadMore"
                    >
                        <span>
                            {{
                                openReadMore
                                    ? $t('md-sold-detail.readLess')
                                    : $t('md-sold-detail.readMore')
                            }}
                        </span>
                        <span class="iconfont icon-expand"></span>
                    </p>
                </div>
            </module-box>
            <module-box>
                <MLS
                    :provided="positionProvided === PROVIDED_POSITION_KEY.under && 'template4'"
                    theme="fashion"
                />
            </module-box>
            <RequestButton theme="fashion" :submitText="submitText" />
            <house-mask v-if="isShowMask" theme="fashion" />
        </template>
        <!-- Mobile end -->
        <!-- PC start -->
        <template v-else>
            <DetailBanner :submitText="submitText" />
            <div class="detail-info" ref="detailInfo">
                <module-box>
                    <div class="left">
                        <!-- other components between Provided top and Provided above -->
                        <Provided
                            v-if="positionProvided && (positionProvided === PROVIDED_POSITION_KEY.above || positionProvided === PROVIDED_POSITION_KEY.top)"
                            theme="template4"
                            class="provided"
                        />
                        <div class="price-box">
                            <price class="price" />
                            <span class="split"></span>
                            <est-price class="est-price" />
                        </div>
                        <!-- Bath/Bed/Sqft start -->
                        <div class="count">
                            <div class="item" v-if="info.bedrooms > 0">
                                <span class="number">
                                    {{ count('bedrooms', info.bedrooms) }}
                                </span>
                                <span class="house">{{
                                    $t('md-sold-detail.bd')
                                }}</span>
                            </div>
                            <div class="item" v-if="info.bathrooms > 0">
                                <span class="number">
                                    {{ count('bathrooms', info.bathrooms) }}
                                </span>
                                <span class="house">{{
                                    $t('md-sold-detail.ba')
                                }}</span>
                            </div>
                            <div
                                class="item"
                                v-if="
                                    info.sqft > 0 ||
                                        info.totalAvailableAcres > 0
                                "
                            >
                                <span class="number">
                                    {{
                                        count(
                                            'sqft',
                                            info.sqft,
                                            info.totalAvailableAcres
                                        )
                                    }}
                                </span>
                                <span class="house">
                                    {{
                                        unit(
                                            'sqft',
                                            info.sqft,
                                            info.totalAvailableAcres
                                        )
                                    }}
                                </span>
                            </div>
                        </div>
                        <!-- Bath/Bed/Sqft start -->

                        <!-- address start -->
                        <template v-if="info.streetAddress || info.cityAddress">
                            <Addr
                                class="address"
                                :class="showCalculator ? '' : 'inline-block no-calculator'"
                            />
                        </template>
                        <!-- address end -->
                        <!-- calculator start -->
                        <template v-if="showCalculator">
                            <div
                                class="calculator"
                                @click="openCaculator('template4')"
                                :class="{ nodisclosure: hidePrice }"
                            >
                                <span class="iconfont icon-caculator">
                                    <span class="payment-text">
                                        {{ cmpPaymentText }}
                                    </span>
                                </span>
                                <span class="separator"></span>
                                <label>
                                    {{
                                        $ft.formatCurrency({
                                            value: hidePrice
                                                ? '-'
                                                : pricePerMonth,
                                            noSpace: true,
                                            currencySymbol
                                        })
                                    }} </label>{{ $t('md-sold-detail.mo') }}
                            </div>
                        </template>
                        <!-- calculator start -->
                        <template v-if="soldDate">
                            <span
                                class="sold-date"
                                :class="showCalculator ? '' : 'no-calculator'"
                            >{{ soldDate }}</span>
                        </template>
                    </div>
                    <div class="right">
                    </div>
                </module-box>
            </div>
            <module-box>
                <div class="float-right" ref="right">
                    <Request theme="fashion" />
                </div>
                <div
                    class="detail-info-group-container"
                    ref="container"
                    :class="{ 'open-read-more': openReadMore }"
                >
                    <DetailInfoGroup
                        ref="group"
                        @refresh-parent="calcShowReadMore"
                    />
                    <p
                        class="read-more"
                        :class="{ open: openReadMore }"
                        v-if="showReadMore"
                        @click="onReadMore"
                    >
                        <span>
                            {{
                                openReadMore
                                    ? $t('md-sold-detail.readLess')
                                    : $t('md-sold-detail.readMore')
                            }}
                        </span>
                        <span class="iconfont icon-expand"></span>
                    </p>
                </div>
            </module-box>
            <module-box>
                <MLS
                    :provided="positionProvided === PROVIDED_POSITION_KEY.under && 'template4'"
                    theme="classic"
                />
            </module-box>
            <house-mask v-if="isShowMask" theme="fashion" />
        </template>
        <!-- PC end -->
        <schema-info :info="seoSchema" v-if="seoSchema" />
    </div>
</template>

<script>
import Common from '../index';
import DetailInfoGroup from '../_components/detail-info-group.vue';
import global from '@/common/global';
import MLS from '../_components/mls.vue';
import DetailBanner from './banner.vue';
import price from './price.vue';
import Provided from '../_components/provided.vue';
import Addr from '../_components/address.vue';
import EstPrice from '../_components/est-price.vue';
import Request from '../_components/est-request.vue';
import RequestButton from '../_components/est-request-button.vue';
import HouseMask from '../_components/mask.vue';
import noDisclosure from '@/components/nodisclosure';
import util from '@/common/util';
export default {
    components: {
        DetailInfoGroup,
        MLS,
        DetailBanner,
        Provided,
        price,
        Addr,
        EstPrice,
        Request,
        RequestButton,
        HouseMask,
        noDisclosure
    },
    mixins: [Common],
    mounted() {
        if (!this.isMobileSize) {
            this.headerHeight = 100;
            let top = window
                .getComputedStyle(this.$refs.right)
                .getPropertyValue('margin-top');

            this.offsetTop = top ? -top.slice(0, -2) : 0;

            global.scroll(this.onScroll);
        }
        this.calcShowReadMore();
    },
    unmounted() {
        if (!this.isMobileSize) {
            global.scroll(this.onScroll, true);
        }
    },
    methods: {
        calcShowReadMore() {
            if (util.isSSRServer) {
                return; 
            }
            this.$nextTick(() => {
                if (
                    this.$refs.group.$el.offsetHeight <
                        this.$refs.group.$el.scrollHeight &&
                    !this.openReadMore
                ) {
                    this.showReadMore = true;
                }
                if (
                    this.$refs.group.$el.offsetHeight > 500 &&
                    this.openReadMore
                ) {
                    this.showReadMore = true;
                }
            });
        },
        onScroll() {
            let right = this.$refs.right;
            if (
                this.$refs.container.offsetHeight <=
                right.offsetHeight - this.offsetTop
            ) {
                if (this.status == 'unactive') {
                    return;
                }
                right.style.position = 'static';
                this.status = 'unactive';
                return;
            }
            let containerRect = this.$refs.container.getBoundingClientRect();
            let rightRect = right.getBoundingClientRect();

            if (containerRect.top > this.headerHeight + this.offsetTop) {
                if (this.status == 'normal') {
                    return; 
                }
                right.style.position = 'static';
                this.status = 'normal';
                return;
            }
            if (containerRect.top <= this.headerHeight + this.offsetTop) {
                if (
                    containerRect.bottom >
                    this.headerHeight + right.offsetHeight
                ) {
                    if (this.status == 'fixed') {
                        return; 
                    }
                    right.style.position = 'fixed';
                    right.style.right = 'auto';
                    right.style.left = rightRect.left + 'px';
                    right.style.top = this.headerHeight + this.offsetTop + 'px';
                    right.style.bottom = 'auto';
                    this.status = 'fixed';
                } else {
                    if (this.status == 'bottom') {
                        return; 
                    }
                    right.style.position = 'absolute';
                    right.style.left = 'auto';
                    right.style.right = '0px';
                    right.style.bottom = '0px';
                    right.style.top = 'auto';
                    this.status = 'bottom';
                }
            }
        }
    }
};
</script>

<style lang="scss">
@import '@/theme/mixin.scss';
@import '@/theme/media.scss';
@import './mobile.scss';
@import './pc.scss';
</style>
